/* eslint-disable camelcase */
import React from "react"
import { accessLevelDescription } from "utils/accessLevelHelpers"
import { auditShape } from "utils/propTypeShapes"

const AccessLevelGrantCreatedAuditItemDetails = ({ audit }) => {
  const {
    associatedType, auditedChanges, grantee, solutionName,
  } = audit
  const { access_level } = auditedChanges

  const renderAccessToObject = () => {
    if (associatedType === "Category") {
      return <span className="font-semibold">{solutionName}</span>
    }
    return ""
  }

  return (
    <div>
      Granted {renderAccessToObject()} {accessLevelDescription(access_level)} access to <span className="font-semibold">{grantee.fullName}</span>.
    </div>
  )
}

AccessLevelGrantCreatedAuditItemDetails.propTypes = {
  audit: auditShape.isRequired,
}

export default AccessLevelGrantCreatedAuditItemDetails
